export const reasonsDescriptionToClose = Object.freeze({
  DELIVERYMAN: 'Falta motoboy',
  STOCKOUT: 'Sem estoque',
  ENERGY: 'Sem energia',
  INTERNET: 'Sem internet',
  OVERTIME: 'Estava fazendo hora extra',
  OTHER: 'Outro',
})

export default Object.freeze({
  DELIVERYMAN: 'DELIVERYMAN',
  STOCKOUT: 'STOCKOUT',
  ENERGY: 'ENERGY',
  INTERNET: 'INTERNET',
  OVERTIME: 'OVERTIME',
  OTHER: 'OTHER',
})
